import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { IItem } from '@coreui/angular-pro';
import { RestService } from 'src/app/services/rest/rest.service';
import { GenericResponse, ProspectiveLeadsResponse, ProspectiveLead } from 'src/app/interfaces/apiresponses';

@Component({
  selector: 'app-support-prospective-customers',
  templateUrl: './support-prospective-customers.component.html',
  styleUrls: ['./support-prospective-customers.component.scss'],
  providers: [DatePipe]
})
export class SupportProspectiveCustomersComponent implements OnInit {
  bUndefined!: boolean
  bAlert = false
  alertHeaderText = ''
  alertBodyText = ''
  bShowSecondAlertButton = false
  alertSecondButtonText = ''
  alertCloseButtonText = 'Close'
  alertBoxData: any

  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  statusOptions = ['ALL', 'Open', 'In Progress', 'Approved', 'Rejected'];

  columns = [
    {
      key: 'createdOn',
      label: 'Created On',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'firstName',
      label: 'First Name',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'lastName',
      label: 'Last Name',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'mobileNumber',
      label: 'Mobile',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'email',
      label: 'Email',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'companyName',
      label: 'Company',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'country',
      label: 'Country',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'leadSource',
      label: 'Source',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'message',
      label: 'Message',
      _cellProps: { align: 'middle' },
      filter: false
    },
        {
      key: 'leadStatus',
      label: 'Status',
      _cellProps: { align: 'middle' },
      filter: true
    },
  ];

  leadsData: IItem[] = []
  selectedItems = [2, 3]
  selectedLead: ProspectiveLead | null = null
  showLeadDetails = false

  leadForm = new FormGroup({
    firstName: new FormControl({ value: '', disabled: true }),
    lastName: new FormControl({ value: '', disabled: true }),
    mobileNumber: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    companyName: new FormControl({ value: '', disabled: true }),
    country: new FormControl({ value: '', disabled: true }),
    message: new FormControl({ value: '', disabled: true }),
    leadSource: new FormControl({ value: '', disabled: true }),
    leadStatus: new FormControl('Open'),
    remarks: new FormControl('')
  })

  searchForm = new FormGroup({
    status: new FormControl('Open')
  })

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    this.loadLeads()
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  onStartDateChane(event: any) {
    this.startDate = event
    this.leadsData = []
  }

  onEndDateChane(event: any) {
    this.endDate = event
    this.leadsData = []
  }

  getDisplayDate(item: any) {
    return this.datePipe.transform(item.createdOn, 'dd-MM-yyyy hh:mm:ss a')
  }

  getDateString(dateValue: Date) {
    return this.datePipe.transform(dateValue, 'yyyy-MM-dd')
  }

  getLeadStatusBadge(status: string | null | undefined) {
    switch ((status || '').toLowerCase()) {
      case 'open':
        return 'warning'
      case 'in progress':
        return 'info'
      case 'approved':
        return 'success'
      case 'rejected':
        return 'danger'
      default:
        return 'secondary'
    }
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = 'Close', showSecondButton: boolean = false, secondButtonText: string = 'Understood', data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  closeAlert(event: any) {}

  alertVisibility(event: any) {
    this.bAlert = event.state
  }

  onAlertButtonClick(event: any) {
    this.bAlert = event.state
  }

  loadLeads() {
    const fromDate = this.getDateString(this.startDate)
    const toDate = this.getDateString(this.endDate)
    const status = this.searchForm.get('status')?.value || 'ALL'

    if (!fromDate || !toDate) {
      this.showAlertBox('Sorry', 'Please correct the dates')
      return
    }

    this.showLeadDetails = false
    this.selectedLead = null

    this.restApi.getProspectiveLeads(fromDate, toDate, status).subscribe({
      next: (v: ProspectiveLeadsResponse) => {
        if (v.success) {
          this.leadsData = v.leads.map((item, Reference) => {
            const _selected = this.selectedItems.includes(Reference);
            return {
              ...item,
              _selected
            };
          })
        } else {
          this.leadsData = []
          this.showAlertBox('Sorry', v.message || 'Unable to load leads')
        }
      },
      error: () => {
        this.showAlertBox('Sorry', 'Something went wrong. Please try again')
      }
    })
  }

  backToList() {
    this.showLeadDetails = false
    this.selectedLead = null
  }

  onRowClick(rowData: any) {
    if (!rowData?.item) return

    const lead: ProspectiveLead = rowData.item
    this.selectedLead = lead
    this.showLeadDetails = true

    this.leadForm.setValue({
      firstName: lead.firstName || '',
      lastName: lead.lastName || '',
      mobileNumber: lead.mobileNumber || '',
      email: lead.email || '',
      companyName: lead.companyName || '',
      country: lead.country || '',
      message: lead.message || '',
      leadSource: lead.leadSource || '',
      leadStatus: lead.leadStatus || 'Open',
      remarks: lead.remarks || ''
    })

    this.leadForm.markAsPristine()
  }

  canUpdateLead(): boolean {
    if (!this.selectedLead) return false

    const currentStatus = this.leadForm.get('leadStatus')?.value || ''
    const currentRemarks = (this.leadForm.get('remarks')?.value || '').trim()
    const statusChanged = currentStatus !== this.selectedLead.leadStatus

    if (statusChanged && !currentRemarks) return false

    return this.leadForm.dirty
  }

  updateLead() {
    if (!this.selectedLead) return

    if (!this.canUpdateLead()) {
      if (this.leadForm.dirty) {
        this.showAlertBox('Sorry', 'Please enter remarks when changing status')
      }
      return
    }

    const newStatus = this.leadForm.get('leadStatus')?.value || ''
    const remarks = this.leadForm.get('remarks')?.value || ''

    this.restApi.updateProspectiveLead(this.selectedLead.leadID, newStatus, remarks).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.showAlertBox('Success', 'Lead updated successfully')
          this.leadForm.markAsPristine()
          this.loadLeads()
        } else {
          this.showAlertBox('Sorry', v.message || 'Unable to update lead')
        }
      },
      error: () => {
        this.showAlertBox('Sorry', 'There was a technical issue. Please contact support')
      }
    })
  }
}
